// Dedicated /pricing route — reuses PricingBlock from LandingPage.
import LandingPage, { PricingBlock } from "@/pages/LandingPage";
import { SEO } from "@/components/SEO";
import { MarketingNav } from "@/components/MarketingNav";
import { MarketingFooter } from "@/components/MarketingFooter";
import { Link } from "react-router-dom";
import { RefreshCcw, Check } from "lucide-react";

export default function PricingPage() {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <SEO
        title="Lectura Pricing: Free Tier, Pro Plans from $7.99/mo"
        description="Lectura pricing: free tier with 3 lectures, Pro from $7.99/mo or $44.99/yr. No credit card required. 30-day money-back guarantee."
        canonical="https://getlectura.app/pricing"
      />
      <MarketingNav />
      <main>
        <section className="border-b border-border/60">
          <div className="mx-auto max-w-3xl px-4 sm:px-6 py-12 text-center">
            <p className="text-xs font-bold uppercase tracking-widest text-accent">Pricing</p>
            <h1 className="mt-2 font-serif text-4xl sm:text-5xl font-bold">Free to start. Fair to keep.</h1>
            <p className="mt-3 text-muted-foreground">
              No credit card for the free tier. Cancel anytime. Every Pro plan is backed by a 30-day money-back guarantee.
            </p>
          </div>
        </section>
        <PricingBlock compact />

        {/* Pricing FAQ */}
        <section className="border-t border-border/60 bg-secondary/30">
          <div className="mx-auto max-w-3xl px-4 sm:px-6 py-14">
            <h2 className="font-serif text-2xl font-bold text-center">Pricing questions</h2>
            <div className="mt-8 space-y-6 text-sm">
              <div>
                <p className="font-semibold">Do I need a credit card to start?</p>
                <p className="text-muted-foreground mt-1">No. The free tier gives you 3 full lectures with slides, guides, and quizzes — no payment info collected.</p>
              </div>
              <div>
                <p className="font-semibold">Can I cancel Pro anytime?</p>
                <p className="text-muted-foreground mt-1">Yes. Cancel from your dashboard in one click. If you cancel within 30 days of any Pro charge, we'll refund it — no questions asked.</p>
              </div>
              <div>
                <p className="font-semibold">Are teachers really free?</p>
                <p className="text-muted-foreground mt-1">Yes. Verified K-12 educators and homeschool parents get free Pro classroom access — <Link to="/for-schools" className="text-accent underline">apply here</Link>.</p>
              </div>
              <div>
                <p className="font-semibold">Is there a school or district plan?</p>
                <p className="text-muted-foreground mt-1">Yes. Districts get seat-based pricing, LTI 1.3 integration for Canvas + Google Classroom, and a Data Processing Agreement — <Link to="/for-schools" className="text-accent underline">contact us</Link>.</p>
              </div>
              <div>
                <p className="font-semibold">What happens after my 3 free lectures?</p>
                <p className="text-muted-foreground mt-1">You keep everything you generated. To make more lectures, upgrade to Pro from $7.99/mo — or wait; there's no time limit on your free tier.</p>
              </div>
            </div>
            <p className="mt-8 text-center text-xs text-muted-foreground inline-flex items-center gap-2 justify-center w-full">
              <RefreshCcw className="h-3 w-3" /> Every Pro plan includes a 30-day money-back guarantee.
            </p>
          </div>
        </section>
      </main>
      <MarketingFooter />
    </div>
  );
}
